import BaseTemplate from "@/templates/Base.vue";
export default [
  {
    path: "/vendas/visao-geral",
    name: "sales",
    component: () => import("../views/sales/SalesIndex.vue"),
    meta: {
      template: BaseTemplate,
      protected: true,
      permissions: ["acessar-vendas"],
      viewContainer: true,
      breadcrumbs: ["sales"]
    }
  },
  {
    path: "/vendas/eventos",
    name: "sales-events",
    component: () => import("../views/sales/EventSales.vue"),
    meta: {
      template: BaseTemplate,
      breadcrumbs: ["sales-events"],
      protected: true,
      permissions: ["acessar-vendas"],
      viewContainer: true
    }
  },
  {
    path: "/vendas/assinaturas",
    name: "sales-subscriptions",
    component: () => import("../views/sales/SubscriptionSales.vue"),
    meta: {
      template: BaseTemplate,
      protected: true,
      permissions: ["acessar-vendas"],
      viewContainer: true,
      breadcrumbs: ["sales", "sales-subscriptions"]
    }
  },
  {
    path: "/vendas/curso-online",
    name: "sales-courses",
    component: () => import("../views/sales/CourseSales.vue"),
    meta: {
      template: BaseTemplate,
      protected: true,
      permissions: ["acessar-vendas"],
      viewContainer: true,
      breadcrumbs: ["sales", "sales-courses"]
    }
  },
  {
    path: "/vendas/recuperacao",
    name: "sales-recovery",
    component: () => import("../views/sales/SaleRecovery.vue"),
    meta: {
      template: BaseTemplate,
      protected: true,
      permissions: ["acessar-vendas"],
      viewContainer: true,
      breadcrumbs: ["sales-recovery"]
    }
  },
  {
    path: "/vendas-presenciais",
    name: "card-machine",
    component: () => import("../views/sales/CardMachine.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["acessar-vendas"],
      viewContainer: true,
      breadcrumbs: ["sales"],
      title: "Vendas presenciais",
      description: "Gerencie vendas na máquina de cartão"
    }
  }
];
